<template>
  <div class="fragment-info-container">
    <img class="back-btn" @click="goBack" src="../../../assets/images/activity/fragment/fragment-info/back.png">

    <div class="point-text">目前积分：{{getPoint}}</div>

    <div class='swiper-box'>

      <swiper ref="mySwiper" :options="swiperOptions" >
        <swiper-slide v-for="(month,index) in pieceMonthList" :key="index">
          <!--活动渠道用户-->
          <div v-if="resultCode=='0'">
            <div class="month">
              <div class="piece" v-for="(item,itemIndex) in month" :class="getPieceStyle(itemIndex)" :key="itemIndex">
                <div v-if="item.count !== 0">
                  <img :src="getImgSrc(index,itemIndex)">
                  <div class="pieceNum-six" v-if="itemIndex === 5"> × {{item.count}}</div>
                  <div v-else> × {{item.count}}</div>
                </div>
                <div v-else>
                  <img :src='getBlankPiece(itemIndex)'>
                </div>
              </div>
           </div>
           <div class="line"></div>
         </div>
         <!--非活动渠道用户-->
         <div v-else class="month" >
           <div class="piece" v-for="(item,index) in pieceMonthList" :key="index" :class="getPieceStyle(index)">
             <img :src='getBlankPiece(index)' >
           </div>
           <div class="line"></div>
         </div>
    </swiper-slide>
    <swiper-slide class="other-piece" >
    </swiper-slide>
  </swiper>

</div>

    <div class="bottom-text">本活动最终解释权归博世易加网所有</div>
  </div>
</template>

<script>
import activityApi from '@/api/activity'
export default {
  data () {
    return {
      month: 0,
      pieceList: [],
      pieceMonthList: [0, 0, 0, 0, 0, 0],
      array: [],
      swiperOptions: {
        initialSlide: this.getInitialSlide(),
        direction: 'vertical',
        slidesPerView: 2,
        mousewheelControl: true,
        freeMode: true,
        roundLengths: true
      },
      index: 0,
      resultCode: '0',
      getPoint: 0
    }
  },

  created () {
    // activityApi.collectPieceList().then(res => {
    //   if (res.data.resultCode === '0') {
    //     // 将获取的36个碎片分为每月6个
    //     let data = res.data.resultData.collectPieceList
    //     for (let i = 0, j = 0; j < 6; i += 6, j++) {
    //       this.pieceMonthList[j] = data.slice(i, i + 6)
    //     }
    //     this.pieceMonthList = Object.assign([], this.pieceMonthList)
    //   }
    // })
    this._getCollectPieceList()
    activityApi.pieceClientActivityInfo().then(res => {
      if (res.data.resultCode === '0') {
        this.getPoint = res.data.resultData.getPoint
      }
    })
  },
  methods: {
    async _getCollectPieceList () {
      let { data } = await activityApi.collectPieceList()
      this.resultCode = data.resultCode
      if (data.resultCode === '0') {
        // 将获取的36个碎片分为每月6个
        let pieceList = data.resultData.collectPieceList
        for (let i = 0, j = 0; j < 6; i += 6, j++) {
          this.pieceMonthList[j] = pieceList.slice(i, i + 6)
        }
        this.pieceMonthList = Object.assign([], this.pieceMonthList)
      }
    },
    getPieceStyle (itemIndex) {
      switch (itemIndex) {
        case 0:
          return 'piece-one'
        case 1:
          return 'piece-two'
        case 2:
          return 'piece-three'
        case 3:
          return 'piece-four'
        case 4:
          return 'piece-five'
        case 5:
          return 'piece-six'
      }
    },
    getImgSrc (i, index) {
      let data = (i + 7) < 10 ? '0' + (i + 7) : i + 7
      let src = require(`../../../assets/images/activity/fragment/home/2021${data}-${index + 1}.png`)
      return src
    },
    getBlankPiece (index) {
      let src = require(`../../../assets/images/activity/fragment/home/2021-p${index + 1}.png`)
      return src
    },
    goBack () {
      this.$router.back()
    },
    getInitialSlide () {
      let index = this.$route.params.index
      if (!index) {
        return 0
      } else {
        return index
      }
    }
  }
}
</script>

<style lang="less" scoped>
 .swiper-container {
    width: 100%;
    height: 80vh;
    color: white;
  }
  .back-btn{
    position: absolute;
    top: 10px;
    height: 90px;
  }
  .point-text{
    position: absolute;
    top: 10vh;
    width: 100%;
    text-align: center;
    color:white;
  }
  .swiper-slide {
    text-align: center;
    font-size: 16px;
    height: 40vh;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .swiper-box{
    margin-top: 100px;
    height: 80vh;
  }

.fragment-info-container{
  width: 100%;
  height: 100vh;
  background-image: url('../../../assets/images/activity/fragment/fragment-info/fragment-info-bg.png');
  background-size: 100%;
  background-color: black;
  overflow: hidden;
  background-attachment: fixed;
  background-repeat: no-repeat;
}
.line{
  position: relative;
  top: -1.5vh;
  width: 90vw;
  height: 1px;
  margin: 0 5vw 0 5vw;
  background-color: rgba(255, 255, 255, 0.295)
}
.month{
  width: 99vw;
  height: 39vh;
  background-color: rgba(250, 235, 215, 0);
  color:white;
  text-align: center;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  .piece{
    width: 30vw;
    height: 19vh;
  }
  .pieceNum{
      margin-top: 15px;
    }
  .piece-one{
    width: 30vw;
    height: 19vh;
    img{
      width: 60%;
    }
  }
  .piece-two{
    width: 30vw;
    height: 19vh;
    img{
      width: 87%;
      margin-bottom: 15px;
    }
  }
  .piece-three{
    width: 30vw;
    height: 19vh;
    img{
      width: 60%;
      margin-bottom: 15px;
    }
  }
  .piece-four{
    width: 30vw;
    height: 15vh;
    img{
      position: relative;
      left: 10px;
      width: 74%;
    }
  }
  .piece-five{
    width: 30vw;
    height: 15vh;
    position: relative;
    top: -18px;
    img{
      width: 61%;
    }
  }
  .pieceNum-six{
    padding-left: 16px;
    }
  .piece-six{
    width: 30vw;
    height: 15vh;
    position: relative;
    top: -15px;
    left: -7px;
    img{
      width: 73%;
    }
  }
  .other-piece{
    width: 30vw;
    height: 19vh;
  }
}
.bottom-text{
    color:#00b6ff ;
    position: relative;
    font-size: 12px;
    top:15px;
    left: -39px;
    transform: scale(0.73);
}
</style>
